export default "__VITE_ASSET__B5Ul6nx5__"